export const EDIT_ASSOCIATION_WARN =
  'Any change in the Associations will remove the pre-selected Permission(s).'
